<template>
  <div class="flex items-center justify-between space-x-2">
    <button
      type="button"
      class="relative flex w-full items-center justify-center space-x-2 rounded-2xl py-3"
      :class="
        isActive(FlowType.AVIA)
          ? 'bg-background-positive-primary text-static-white'
          : 'bg-background-neutral-secondary text-text-neutral-secondary'
      "
      @click="switchApp(FlowType.AVIA)"
    >
      <!-- prettier-ignore -->
      <svg :class="isActive(FlowType.AVIA) ? 'text-static-white' : 'text-text-positive-primary'" width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.175 2.092s-.747.203-1.357.541-1.005.58-2.172 1.737c-1.253 1.243-2.353 2.37-2.353 2.37s-3.524 4.073-4.26 5.086c-.859 1.183-1.016 1.355-1.42 1.554-.566.279-.834.287-2.16.064-.99-.167-1.223-.189-1.493-.145-.525.086-.882.3-1.447.867-.474.475-.513.53-.513.734 0 .156.036.252.125.334.068.063.965.53 1.993 1.039 2.518 1.245 2.306 1.031 3.59 3.614.524 1.055.992 1.962 1.039 2.015.055.064.166.098.315.098.219 0 .258-.028.758-.544.566-.584.737-.868.833-1.39.053-.285.039-.456-.113-1.368-.21-1.265-.22-1.737-.044-2.169.185-.452.382-.682.917-1.07.262-.19.751-.553 1.086-.805.336-.252.677-.474.76-.493.278-.063.493.1.751.573.13.238.356.646.502.907l1.752 3.124c.817 1.457 1.546 2.706 1.62 2.775.274.256.412.19 1.137-.53.795-.79.989-1.122 1.027-1.759.022-.375-.044-.675-.981-4.447-.966-3.888-1.004-4.062-.987-4.518.03-.8.101-.907 1.67-2.504.986-1.002 1.516-1.558 1.823-2.138.243-.459.45-.989.425-1.656v-.03c-.018-.47-.029-.787-.3-1.178-.265-.383-.535-.527-.97-.687-.57-.209-1.553-.001-1.553-.001Z" fill="currentColor"/><path d="M9.118 4.824c-3.763-.95-4.07-1.02-4.4-.988-.592.055-.985.282-1.676.967-.662.657-.772.852-.634 1.12.082.161.314.3 4.106 2.455 1.485.844 2.223 1.028 2.615 1.1.226.04.52-.035.672-.209l2.497-2.874c.22-.254.069-.681-.255-.773-.515-.145-1.316-.392-2.925-.798Z" fill="url(#a)"/><defs><linearGradient id="a" x1="2.998" y1="6" x2="13.498" y2="7" gradientUnits="userSpaceOnUse"><stop stop-color="currentColor" stop-opacity=".4"/><stop offset="1" stop-color="currentColor"/></linearGradient></defs></svg>
      <span class="text-xs font-medium">{{ t('appSwitchButton.avia') }}</span>
      <ActiveIndicator
        v-if="isActive(FlowType.AVIA)"
        class="absolute -bottom-2 left-[calc(50%-18px)]"
      />
    </button>
    <button
      type="button"
      class="relative flex w-full items-center justify-center space-x-2 rounded-2xl py-3"
      :class="
        isActive(FlowType.RAILWAYS)
          ? 'bg-background-positive-primary text-static-white'
          : 'bg-background-neutral-secondary text-text-neutral-secondary'
      "
      @click="switchApp(FlowType.RAILWAYS)"
    >
      <img
        v-if="isActive(FlowType.RAILWAYS)"
        src="./assets/train-white.svg"
        width="24"
        height="24"
        alt=""
        role="presentation"
      />
      <img
        v-else
        src="./assets/train-green.svg"
        width="24"
        height="24"
        alt=""
        role="presentation"
      />
      <span class="text-xs font-medium">{{
        t('appSwitchButton.railways')
      }}</span>
      <ActiveIndicator
        v-if="isActive(FlowType.RAILWAYS)"
        class="absolute -bottom-2 left-[calc(50%-18px)]"
      />
    </button>
    <button
      type="button"
      class="relative flex w-full items-center justify-center space-x-2 rounded-2xl py-3"
      :class="
        isActive(FlowType.TOURS)
          ? 'bg-background-positive-primary text-static-white'
          : 'bg-background-neutral-secondary text-text-neutral-secondary'
      "
      @click="switchApp(FlowType.TOURS)"
    >
      <img
        v-if="isActive(FlowType.TOURS)"
        src="./assets/tours-white.svg"
        width="24"
        height="24"
        alt=""
        role="presentation"
      />
      <img
        v-else
        src="./assets/tours-green.svg"
        width="24"
        height="24"
        alt=""
        role="presentation"
      />
      <span class="text-xs font-medium">{{ t('appSwitchButton.tours') }}</span>
      <ActiveIndicator
        v-if="isActive(FlowType.TOURS)"
        class="absolute -bottom-2 left-[calc(50%-18px)]"
      />
    </button>
  </div>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n';

  import { FlowType } from '../../shared/config';
  import ActiveIndicator from './ActiveIndicator.vue';

  const props = defineProps<{ activeApp: FlowType; sourcePage?: string }>();
  const emit = defineEmits<{
    onMiniAppSwitch: [app: FlowType];
  }>();

  const { t } = useI18n();

  const isActive = (miniAppName: FlowType) => miniAppName === props.activeApp;

  function switchApp(appName: FlowType) {
    /** To prevent reopening active app */
    const isTryingToOpenActiveApp = isActive(appName);

    if (!isTryingToOpenActiveApp) {
      emit('onMiniAppSwitch', appName);
    }
  }
</script>

<i18n src="./config/locales.json"></i18n>
